/* ==========================================================================
   Frontend Application Script - Minimalist Local Life
   ========================================================================== */
// --- Decryption Helper ---
function deobfuscate(base64Str) {
    const key = "xilinwang2026";
    const binaryStr = atob(base64Str);
    const bytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
    }
    const s = new Array(256);
    for (let i = 0; i < 256; i++) s[i] = i;
    let j = 0;
    const keyBytes = [];
    for (let i = 0; i < key.length; i++) {
        keyBytes.push(key.charCodeAt(i));
    }
    for (let i = 0; i < 256; i++) {
        j = (j + s[i] + keyBytes[i % keyBytes.length]) % 256;
        const temp = s[i]; s[i] = s[j]; s[j] = temp;
    }
    let x = 0, y = 0;
    const resultBytes = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
        x = (x + 1) % 256;
        y = (y + s[x]) % 256;
        const temp = s[x]; s[x] = s[y]; s[y] = temp;
        const k = s[(s[x] + s[y]) % 256];
        resultBytes[i] = bytes[i] ^ k;
    }
    const decoder = new TextDecoder("utf-8");
    const jsonStr = decoder.decode(resultBytes);
    return JSON.parse(jsonStr);
}

// --- Global Application State ---
const State = {
    userToken: localStorage.getItem('userToken') || null,
    userPhone: localStorage.getItem('userPhone') || null,
    isAdmin: localStorage.getItem('isAdmin') === 'true',
    currentTab: 'all', // 'all' or 'my'
    searchQuery: '',
    page: 1,
    limit: 16,
    loading: false,
    hasMore: true,
    records: [],
    selectedImageBlobs: [], // Holds array of: { id: number, file: Blob, previewUrl: string, name: string }
    smsCooldown: 0,
    smsTimer: null,
    pendingPublish: false, // Flag to resume publishing after SMS auth succeeds
    pendingCount: 0,
    adminFilterStatus: 'Pending', // 'all', 'Pending', 'Approved', 'Rejected'
    
    // Lightbox Gallery State
    lightboxImages: [],
    lightboxIndex: 0,
    resetZoom: null // Will be populated in bindEvents
};

// --- DOM Elements ---
const DOM = {
    btnTogglePublish: document.getElementById('btn-toggle-publish'),
    publishCard: document.getElementById('publish-card'),
    btnClosePublish: document.getElementById('btn-close-publish'),
    btnFloatPublish: document.getElementById('btn-float-publish'),
    btnSync: document.getElementById('btn-sync'),
    btnToggleSearch: document.getElementById('btn-toggle-search'),
    
    searchInput: document.getElementById('search-input'),
    btnClearSearch: document.getElementById('btn-clear-search'),
    searchStatus: document.getElementById('search-status'),
    searchStatusText: document.getElementById('search-status-text'),
    btnClearSearchStatus: document.getElementById('btn-clear-search-status'),
    tagsContainer: document.getElementById('tags-container'),
    
    publishForm: document.getElementById('publish-form'),
    publishContent: document.getElementById('publish-content'),
    fileInput: document.getElementById('file-input'),
    uploadZone: document.getElementById('upload-zone'),
    uploadPrompt: document.querySelector('.upload-prompt'),
    uploadPreviewGrid: document.getElementById('upload-preview-grid'),
    btnPublish: document.getElementById('btn-publish'),
    
    searchSection: document.querySelector('.search-section'),
    myFeedHeader: document.getElementById('my-feed-header'),
    btnFeedShowAll: document.getElementById('btn-feed-show-all'),
    btnFeedPending: document.getElementById('btn-feed-pending'),
    btnFeedBackup: document.getElementById('btn-feed-backup'),
    btnFeedCopySummary: document.getElementById('btn-feed-copy-summary'),
    btnFeedLogout: document.getElementById('btn-feed-logout'),
    
    feedLoading: document.getElementById('feed-loading'),
    feedEmpty: document.getElementById('feed-empty'),
    feedGrid: document.getElementById('feed-grid'),
    infiniteScrollLoader: document.getElementById('infinite-scroll-loader'),
    
    authModal: document.getElementById('auth-modal'),
    btnCloseModal: document.getElementById('btn-close-modal'),
    authForm: document.getElementById('auth-form'),
    authPhone: document.getElementById('auth-phone'),
    authCode: document.getElementById('auth-code'),
    btnSendCode: document.getElementById('btn-send-code'),
    btnSubmitAuth: document.getElementById('btn-submit-auth'),
    modalTitle: document.getElementById('modal-title'),
    modalDesc: document.getElementById('modal-desc'),
    
    // Lightbox modal elements
    imageModal: document.getElementById('image-modal'),
    btnCloseImage: document.getElementById('btn-close-image'),
    btnPrevImage: document.getElementById('btn-prev-image'),
    btnNextImage: document.getElementById('btn-next-image'),
    lightboxImg: document.getElementById('lightbox-img'),
    lightboxCounter: document.getElementById('lightbox-counter'),
    
    toastContainer: document.getElementById('toast-container'),

    // Admin Edit modal elements
    adminFilterTabs: document.getElementById('admin-filter-tabs'),
    smsStatsPanel: document.getElementById('sms-stats-panel'),
    smsStatTotal: document.getElementById('sms-stat-total'),
    smsStatSuccess: document.getElementById('sms-stat-success'),
    smsStatFailed: document.getElementById('sms-stat-failed'),
    btnSmsDetail: document.getElementById('btn-sms-detail'),
    smsFailuresList: document.getElementById('sms-failures-list'),
    editModal: document.getElementById('edit-modal'),
    btnCloseEdit: document.getElementById('btn-close-edit'),
    btnCancelEdit: document.getElementById('btn-cancel-edit'),
    editForm: document.getElementById('edit-form'),
    editRecordId: document.getElementById('edit-record-id'),
    editContent: document.getElementById('edit-content'),
    editExistingImagesGrid: document.getElementById('edit-existing-images-grid'),
    editUploadZone: document.getElementById('edit-upload-zone'),
    editFileInput: document.getElementById('edit-file-input'),
    editUploadPreviewGrid: document.getElementById('edit-upload-preview-grid')
};

// --- Initializer ---
document.addEventListener('DOMContentLoaded', () => {
    initUserBadge();
    bindEvents();

    // SEO: Read ?q= URL parameter to support shareable search URLs
    const urlParams = new URLSearchParams(window.location.search);
    const urlQuery = urlParams.get('q');
    if (urlQuery) {
        State.searchQuery = urlQuery.trim();
        DOM.searchInput.value = State.searchQuery;
        if (State.searchQuery) {
            DOM.btnClearSearch.classList.remove('hidden');
            document.title = `${State.searchQuery} - 锡林网搜索结果 | 锡林浩特本地生活信息`;
        }
    }

    updateSearchStatus(null, Boolean(State.searchQuery));

    // Check for server-preloaded records to avoid content flash
    if (window.__PRELOADED_RECORDS__ && window.__PRELOADED_RECORDS__.length > 0) {
        State.records = window.__PRELOADED_RECORDS__;
        State.hasMore = true;
        DOM.feedLoading.classList.add('hidden');
        // The HTML already has server-rendered cards, so we're in sync.
        // Quietly refresh in background to pick up any new content.
        setTimeout(() => {
            if (State.currentTab === 'all' && !State.searchQuery) {
                loadFeed(true);
            }
        }, 3000);
    } else {
        loadFeed(true);
    }

    // Restore draft from localStorage
    restoreDraft();

    // --- iOS Bounce / Rubber-band Prevention ---
    let touchStartY = 0;
    document.addEventListener('touchstart', (e) => {
        touchStartY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchmove', (e) => {
        // Allow scrolling inside scrollable sub-elements (e.g. modals)
        let el = e.target;
        while (el && el !== document.body) {
            const style = window.getComputedStyle(el);
            const overflow = style.overflowY;
            if ((overflow === 'auto' || overflow === 'scroll') && el.scrollHeight > el.clientHeight) {
                return; // Let inner scroll happen normally
            }
            el = el.parentElement;
        }
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const scrollMax = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const dy = e.touches[0].clientY - touchStartY;
        // Swiping down (dy > 0) at the very top → block pull-down bounce
        // Swiping up (dy < 0) at the very bottom → block push-up bounce
        if ((dy > 0 && scrollTop <= 0) || (dy < 0 && scrollTop >= scrollMax)) {
            e.preventDefault();
        }
    }, { passive: false });
});

// --- Event Bindings ---
function bindEvents() {
    // 放大镜：展开/收起 搜索框 + 热词
    if (DOM.btnToggleSearch) {
        DOM.btnToggleSearch.addEventListener('click', () => {
            const open = DOM.searchSection.classList.toggle('open');
            if (open) {
                setTimeout(() => DOM.searchInput && DOM.searchInput.focus(), 300);
            }
        });
    }

    // Toggle Publish Section
    DOM.btnTogglePublish.addEventListener('click', () => {
        DOM.publishCard.classList.toggle('hidden');
        if (!DOM.publishCard.classList.contains('hidden')) {
            DOM.publishContent.focus();
            setTimeout(() => {
                const headerEl = document.querySelector('.page-top-bg') || DOM.searchSection;
                const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
                const elementTop = DOM.publishCard.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: elementTop - headerHeight - 12,
                    behavior: 'smooth'
                });
            }, 50);
        }
    });

    // Floating Back To Top Button
    if (DOM.btnFloatPublish) {
        DOM.btnFloatPublish.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    DOM.btnClosePublish.addEventListener('click', () => {
        DOM.publishCard.classList.add('hidden');
    });

    // Auth & Sync
    DOM.btnSync.addEventListener('click', () => {
        if (State.userToken && State.userPhone) {
            switchTab('my');
        } else {
            openAuthModal('device_sync');
        }
    });
    DOM.btnFeedShowAll.addEventListener('click', () => switchTab('all'));
    if (DOM.btnFeedPending) {
        DOM.btnFeedPending.addEventListener('click', () => switchTab('pending'));
    }
    DOM.btnFeedLogout.addEventListener('click', handleLogout);
    DOM.btnSmsDetail?.addEventListener('click', toggleSmsDetail);
    DOM.btnCloseModal.addEventListener('click', closeAuthModal);
    DOM.authModal.addEventListener('click', (e) => {
        if (e.target === DOM.authModal) closeAuthModal();
    });
    DOM.btnSendCode.addEventListener('click', handleSendSmsCode);
    DOM.authForm.addEventListener('submit', handleVerifySmsCode);
    
    // Search input
    let searchDebounce = null;
    DOM.searchInput.addEventListener('input', (e) => {
        State.searchQuery = e.target.value.trim();
        if (State.searchQuery) {
            DOM.btnClearSearch.classList.remove('hidden');
        } else {
            DOM.btnClearSearch.classList.add('hidden');
        }
        updateSearchStatus(null, State.searchQuery.length >= 2);
        
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(() => {
            if (State.currentTab === 'all') {
                // Only trigger search if input is empty (cleared) OR at least 2 characters
                if (State.searchQuery.length === 0 || State.searchQuery.length >= 2) {
                    loadFeed(true);
                    if (State.searchQuery) addSearchHistory(State.searchQuery);
                    // SEO: Update URL and title for shareable search results
                    if (State.searchQuery) {
                        const newUrl = `${window.location.pathname}?q=${encodeURIComponent(State.searchQuery)}`;
                        history.replaceState(null, '', newUrl);
                        document.title = `${State.searchQuery} - 锡林网搜索结果 | 锡林浩特本地生活信息`;
                    } else {
                        history.replaceState(null, '', window.location.pathname);
                        document.title = '锡林网 - 本地生活信息流平台';
                    }
                }
            }
        }, 400);
    });
    
    const clearSearch = () => {
        DOM.searchInput.value = '';
        State.searchQuery = '';
        DOM.btnClearSearch.classList.add('hidden');
        // 清除搜索后收起搜索框（回到紧凑头部）
        if (DOM.searchSection) DOM.searchSection.classList.remove('open');
        updateSearchStatus();
        if (State.currentTab === 'all') {
            loadFeed(true);
            // SEO: Reset URL and title
            history.replaceState(null, '', window.location.pathname);
            document.title = '锡林网 - 本地生活信息流平台';
        }
    };

    DOM.btnClearSearch.addEventListener('click', clearSearch);
    DOM.btnClearSearchStatus.addEventListener('click', clearSearch);

    // Upload & Drag-Drop
    DOM.uploadZone.addEventListener('click', (e) => {
        if (e.target.closest('.btn-remove-preview') || e.target.closest('.upload-preview-item')) return;
        DOM.fileInput.click();
    });
    
    DOM.fileInput.addEventListener('change', handleFileSelect);
    
    DOM.uploadZone.addEventListener('dragover', (e) => {
        e.preventDefault();
        DOM.uploadZone.style.borderColor = 'var(--primary)';
    });
    
    DOM.uploadZone.addEventListener('dragleave', () => {
        DOM.uploadZone.style.borderColor = 'var(--border-color)';
    });
    
    DOM.uploadZone.addEventListener('drop', (e) => {
        e.preventDefault();
        DOM.uploadZone.style.borderColor = 'var(--border-color)';
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            processSelectedFiles(e.dataTransfer.files);
        }
    });

    // Form Submit
    DOM.publishForm.addEventListener('submit', handlePublishSubmit);

    // Auto-save draft on input
    DOM.publishContent.addEventListener('input', () => {
        saveDraft();
    });

    // Admin Edit Event Listeners
    DOM.btnCloseEdit?.addEventListener('click', closeEditModal);
    DOM.btnCancelEdit?.addEventListener('click', closeEditModal);
    DOM.editModal?.addEventListener('click', (e) => {
        if (e.target === DOM.editModal) closeEditModal();
    });
    DOM.editUploadZone?.addEventListener('click', (e) => {
        if (e.target.closest('.btn-remove-preview') || e.target.closest('.upload-preview-item')) return;
        DOM.editFileInput.click();
    });
    DOM.editFileInput?.addEventListener('change', handleEditFileSelect);
    DOM.editForm?.addEventListener('submit', handleEditFormSubmit);
    DOM.btnFeedBackup?.addEventListener('click', handleBackupClick);
    DOM.btnFeedCopySummary?.addEventListener('click', handleCopySummaryClick);

    // Admin Filter Tab Event Listeners
    DOM.adminFilterTabs?.addEventListener('click', (e) => {
        const tabBtn = e.target.closest('.filter-tab');
        if (!tabBtn) return;

        // Toggle active style
        DOM.adminFilterTabs.querySelectorAll('.filter-tab').forEach(btn => {
            btn.classList.remove('active');
            btn.style.background = 'var(--bg-input)';
            btn.style.color = 'var(--text-secondary)';
            btn.style.fontWeight = 'normal';
        });
        tabBtn.classList.add('active');
        tabBtn.style.background = 'var(--primary)';
        tabBtn.style.color = '#fff';
        tabBtn.style.fontWeight = '600';

        State.adminFilterStatus = tabBtn.dataset.status;
        loadFeed(true);
    });

    // Infinite Scroll Pagination & Floating Publish Button
    window.addEventListener('scroll', () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        // Show/hide floating publish button
        if (DOM.btnFloatPublish) {
            if (scrollTop > 300) {
                DOM.btnFloatPublish.classList.add('show');
            } else {
                DOM.btnFloatPublish.classList.remove('show');
            }
        }

        if ((State.currentTab !== 'all' && State.currentTab !== 'pending') || State.loading || !State.hasMore) return;
        
        const windowHeight = window.innerHeight;
        const docHeight = document.documentElement.scrollHeight;
        
        if (scrollTop + windowHeight >= docHeight - 200) {
            State.page++;
            loadFeed(false);
        }
    }, { passive: true });

    // Image Lightbox Close & Navigation
    DOM.btnCloseImage.addEventListener('click', () => {
        DOM.imageModal.classList.add('hidden');
    });
    DOM.imageModal.addEventListener('click', (e) => {
        if (e.target === DOM.imageModal) {
            DOM.imageModal.classList.add('hidden');
        }
    });
    DOM.btnPrevImage.addEventListener('click', () => navigateLightbox(-1));
    DOM.btnNextImage.addEventListener('click', () => navigateLightbox(1));

    // Keyboard controls for Lightbox
    document.addEventListener('keydown', (e) => {
        if (DOM.imageModal.classList.contains('hidden')) return;
        if (e.key === 'ArrowLeft') {
            navigateLightbox(-1);
        } else if (e.key === 'ArrowRight') {
            navigateLightbox(1);
        } else if (e.key === 'Escape') {
            DOM.imageModal.classList.add('hidden');
        }
    });

    // Swipe controls for Lightbox
    let touchStartX = 0;
    let touchEndX = 0;
    DOM.imageModal.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    DOM.imageModal.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    }, { passive: true });

    function handleSwipe() {
        if (State.lightboxImages.length <= 1 || zoomScale > 1) return; // Disable swipe while zoomed
        const diff = touchEndX - touchStartX;
        if (Math.abs(diff) > 50) {
            if (diff < 0) {
                navigateLightbox(1); // Swipe left -> Next
            } else {
                navigateLightbox(-1); // Swipe right -> Prev
            }
        }
    }

    // --- Mobile Pinch Zoom & Pan Implementation on Lightbox Image ---
    let zoomScale = 1;
    let zoomTranslateX = 0;
    let zoomTranslateY = 0;
    let lastTouchTime = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartY = 0;
    let initTouchDist = 0;
    let initScale = 1;

    function resetZoom() {
        zoomScale = 1;
        zoomTranslateX = 0;
        zoomTranslateY = 0;
        applyZoomTransform();
    }

    function applyZoomTransform() {
        DOM.lightboxImg.style.transform = `translate(${zoomTranslateX}px, ${zoomTranslateY}px) scale(${zoomScale})`;
    }

    // Expose resetZoom to global/State state so it resets on image transitions
    State.resetZoom = resetZoom;

    DOM.lightboxImg.addEventListener('touchstart', (e) => {
        if (e.touches.length === 1) {
            const now = Date.now();
            if (now - lastTouchTime < 300) {
                // Double tap zoom toggle (1x <-> 2.5x)
                if (zoomScale > 1) {
                    resetZoom();
                } else {
                    zoomScale = 2.5;
                    // Centering zoom helper
                    zoomTranslateX = 0;
                    zoomTranslateY = 0;
                    applyZoomTransform();
                }
                e.preventDefault();
                return;
            }
            lastTouchTime = now;

            if (zoomScale > 1) {
                isDragging = true;
                dragStartX = e.touches[0].clientX - zoomTranslateX;
                dragStartY = e.touches[0].clientY - zoomTranslateY;
            }
        } else if (e.touches.length === 2) {
            isDragging = false;
            initTouchDist = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
            );
            initScale = zoomScale;
        }
    }, { passive: false });

    DOM.lightboxImg.addEventListener('touchmove', (e) => {
        if (isDragging && e.touches.length === 1 && zoomScale > 1) {
            e.preventDefault();
            zoomTranslateX = e.touches[0].clientX - dragStartX;
            zoomTranslateY = e.touches[0].clientY - dragStartY;
            applyZoomTransform();
        } else if (e.touches.length === 2) {
            e.preventDefault();
            const dist = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
            );
            if (dist > 0 && initTouchDist > 0) {
                zoomScale = Math.min(Math.max(initScale * (dist / initTouchDist), 1), 4);
                if (zoomScale === 1) {
                    zoomTranslateX = 0;
                    zoomTranslateY = 0;
                }
                applyZoomTransform();
            }
        }
    }, { passive: false });

    DOM.lightboxImg.addEventListener('touchend', (e) => {
        isDragging = false;
        if (e.touches.length < 2) {
            initTouchDist = 0;
        }
    });

    // --- Pull to Refresh ---
    let pullStartY = 0;
    let pullStartX = 0;
    let isPulling = false;
    const pullIndicator = document.getElementById('pull-to-refresh');
    const pullText = pullIndicator?.querySelector('.pull-to-refresh-text');

    if (pullIndicator && pullText) {
        window.addEventListener('touchstart', (e) => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            if (scrollTop === 0 && e.touches.length === 1) {
                pullStartY = e.touches[0].pageY;
                pullStartX = e.touches[0].pageX;
                isPulling = true;
                pullIndicator.classList.add('active');
                pullIndicator.style.transition = 'none';
            }
        }, { passive: true });

        window.addEventListener('touchmove', (e) => {
            if (!isPulling) return;

            const currentY = e.touches[0].pageY;
            const currentX = e.touches[0].pageX;
            const diffY = currentY - pullStartY;
            const diffX = currentX - pullStartX;

            if (diffY < 0 || Math.abs(diffX) > diffY) {
                isPulling = false;
                pullIndicator.classList.remove('active');
                pullIndicator.style.marginTop = '-50px';
                return;
            }

            const pullDistance = Math.min(diffY * 0.4, 75);
            
            if (pullDistance > 10) {
                if (e.cancelable) e.preventDefault();
            }

            pullIndicator.style.marginTop = `${pullDistance - 50}px`;

            if (pullDistance >= 50) {
                pullText.textContent = '释放立即刷新';
            } else {
                pullText.textContent = '下拉刷新';
            }
        }, { passive: false });

        window.addEventListener('touchend', (e) => {
            if (!isPulling) return;
            isPulling = false;

            const currentMarginTop = parseFloat(pullIndicator.style.marginTop || '-50');
            const pullDistance = currentMarginTop + 50;

            pullIndicator.style.transition = 'margin-top 0.2s cubic-bezier(0.4, 0, 0.2, 1)';

            if (pullDistance >= 50) {
                pullIndicator.classList.add('refreshing');
                pullText.textContent = '正在刷新...';
                pullIndicator.style.marginTop = '0px';

                loadFeed(true).finally(() => {
                    pullIndicator.style.marginTop = '-50px';
                    pullIndicator.classList.remove('refreshing');
                    pullIndicator.classList.remove('active');
                    setTimeout(() => {
                        pullText.textContent = '下拉刷新';
                    }, 200);
                });
            } else {
                pullIndicator.style.marginTop = '-50px';
                pullIndicator.classList.remove('active');
            }
        }, { passive: true });
    }
}


// --- Auth Handling ---
function initUserBadge() {
    if (State.userToken && State.userPhone) {
        if (DOM.btnSync) {
            DOM.btnSync.style.color = 'var(--accent)';
            DOM.btnSync.title = `已登录 (${maskPhoneNumber(State.userPhone)})`;
        }
        if (State.isAdmin) {
            DOM.btnFeedPending?.classList.remove('hidden');
            DOM.btnFeedBackup?.classList.remove('hidden');
            DOM.btnFeedCopySummary?.classList.remove('hidden');
            updatePendingButton();
            loadSmsStats();
        } else {
            DOM.btnFeedPending?.classList.add('hidden');
            DOM.btnFeedBackup?.classList.add('hidden');
            DOM.btnFeedCopySummary?.classList.add('hidden');
        }
    } else {
        if (DOM.btnSync) {
            DOM.btnSync.style.color = '';
            DOM.btnSync.title = '登录 / 找回发布';
        }
        DOM.btnFeedPending?.classList.add('hidden');
        DOM.btnFeedBackup?.classList.add('hidden');
        DOM.btnFeedCopySummary?.classList.add('hidden');
    }
}

function updatePendingButton() {
    if (!State.isAdmin) return;
    if (DOM.btnFeedPending) {
        DOM.btnFeedPending.textContent = State.pendingCount > 0 ? `待审核 ${State.pendingCount}` : '待审核';
    }
}

function updatePendingHeader() {
    // Pending count is shown on the button badge - no separate header title needed
}

// Element UI 风格确认框（ElMessageBox）
function showConfirm(message, title = '提示') {
    return new Promise((resolve) => {
        const overlay = document.createElement('div');
        overlay.className = 'el-messagebox-overlay';
        overlay.innerHTML = `
            <div class="el-messagebox">
                <div class="el-messagebox-title">${title}</div>
                <div class="el-messagebox-message">${message}</div>
                <div class="el-messagebox-btns">
                    <button class="el-messagebox-cancel">取消</button>
                    <button class="el-messagebox-confirm">确定</button>
                </div>
            </div>
        `;
        document.body.appendChild(overlay);
        requestAnimationFrame(() => overlay.classList.add('show'));
        const close = (result) => {
            overlay.classList.remove('show');
            setTimeout(() => overlay.remove(), 200);
            resolve(result);
        };
        overlay.querySelector('.el-messagebox-cancel').addEventListener('click', () => close(false));
        overlay.querySelector('.el-messagebox-confirm').addEventListener('click', () => close(true));
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(false); });
    });
}

async function handleLogout() {
    const ok = await showConfirm('确定退出？');
    if (!ok) return;
    localStorage.removeItem('userToken');
    localStorage.removeItem('userPhone');
    localStorage.removeItem('isAdmin');
    State.userToken = null;
    State.userPhone = null;
    State.isAdmin = false;
    State.pendingCount = 0;
    DOM.smsStatsPanel?.classList.add('hidden');
    DOM.smsFailuresList?.classList.add('hidden');
    initUserBadge();
    showToast('已退出登录，管理凭证已清除', 'success');
    
    // Force tab reset and reload feed to wipe admin markup immediately
    State.currentTab = '';
    switchTab('all');
}

function openAuthModal(mode = 'publish') {
    if (mode === 'device_sync') {
        DOM.modalTitle.textContent = '找回发布记录 / 跨设备同步';
        DOM.modalDesc.textContent = '输入手机号获取验证码，同步该手机在其他设备或历史浏览器中生成的管理权限。';
        State.pendingPublish = false;
    } else {
        DOM.modalTitle.textContent = '首次发布验证';
        DOM.modalDesc.textContent = '输入手机号完成一次验证。验证成功后会自动继续刚才的发布，并绑定本设备用于后续管理。';
        State.pendingPublish = true;
    }
    
    DOM.authPhone.value = '';
    DOM.authCode.value = '';
    DOM.authModal.classList.remove('hidden');
}

function closeAuthModal() {
    DOM.authModal.classList.add('hidden');
    State.pendingPublish = false;
}

async function handleSendSmsCode() {
    if (State.smsCooldown > 0) return;
    
    const phone = DOM.authPhone.value.trim();
    if (!/^1[3-9]\d{9}$/.test(phone)) {
        showToast('请输入正确的11位手机号', 'error');
        return;
    }

    DOM.btnSendCode.disabled = true;
    DOM.btnSendCode.textContent = '发送中...';

    try {
        const response = await fetch('/api/sms/send', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ phone })
        });
        
        const data = await response.json();
        
        if (response.ok) {
            showToast('验证码发送成功！', 'success');
            startSmsCooldown();
        } else {
            showToast(data.error || '验证码发送失败', 'error');
            DOM.btnSendCode.disabled = false;
            DOM.btnSendCode.textContent = '发送验证码';
        }
    } catch (err) {
        showToast('网络错误，请稍后重试', 'error');
        DOM.btnSendCode.disabled = false;
        DOM.btnSendCode.textContent = '发送验证码';
    }
}

function startSmsCooldown() {
    State.smsCooldown = 60;
    DOM.btnSendCode.disabled = true;
    
    State.smsTimer = setInterval(() => {
        State.smsCooldown--;
        if (State.smsCooldown <= 0) {
            clearInterval(State.smsTimer);
            DOM.btnSendCode.disabled = false;
            DOM.btnSendCode.textContent = '发送验证码';
        } else {
            DOM.btnSendCode.textContent = `${State.smsCooldown}s后重发`;
        }
    }, 1000);
}

async function handleVerifySmsCode() {
    const phone = DOM.authPhone.value.trim();
    const code = DOM.authCode.value.trim();
    
    if (!phone || !code) return;

    DOM.btnSubmitAuth.disabled = true;
    DOM.btnSubmitAuth.textContent = '验证中...';

    try {
        const response = await fetch('/api/sms/verify', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ phone, code })
        });
        
        const data = await response.json();
        
        if (response.ok) {
            localStorage.setItem('userToken', data.token);
            localStorage.setItem('userPhone', data.phone);
            localStorage.setItem('isAdmin', data.isAdmin ? 'true' : 'false');
            State.userToken = data.token;
            State.userPhone = data.phone;
            State.isAdmin = !!data.isAdmin;
            
            initUserBadge();
            closeAuthModal();
            showToast(data.isAdmin ? '管理员身份验证成功！' : '身份验证成功！', 'success');
            
            if (State.pendingPublish) {
                handlePublishSubmit();
            }
        } else {
            showToast(data.error || '验证失败，请重新检查', 'error');
        }
    } catch (err) {
        showToast('网络错误，请重试', 'error');
    } finally {
        DOM.btnSubmitAuth.disabled = false;
        DOM.btnSubmitAuth.textContent = '确定验证';
    }
}

// --- Multiple Image Compression & Selection ---
function handleFileSelect(e) {
    if (e.target.files && e.target.files.length > 0) {
        processSelectedFiles(e.target.files);
    }
}

function processSelectedFiles(fileList) {
    const filesArray = Array.from(fileList);
    const validImageFiles = filesArray.filter(file => file.type.startsWith('image/'));

    if (validImageFiles.length === 0) {
        showToast('只支持上传图片格式文件', 'error');
        return;
    }

    if (State.selectedImageBlobs.length + validImageFiles.length > 9) {
        showToast('最多只能上传 9 张图片', 'warning');
        return;
    }

    validImageFiles.forEach(file => {
        const itemId = Date.now() + Math.random();
        const previewUrl = URL.createObjectURL(file);

        const newImgItem = {
            id: itemId,
            previewUrl: previewUrl,
            file: null, // Populated after compression completes
            name: file.name
        };

        State.selectedImageBlobs.push(newImgItem);
        renderPreviewGrid();

        // Compress client-side
        compressImage(file, 1200, 0.75).then(compressedBlob => {
            const item = State.selectedImageBlobs.find(x => x.id === itemId);
            if (item) {
                item.file = compressedBlob;
                const originalSize = (file.size / 1024).toFixed(0);
                const compressedSize = (compressedBlob.size / 1024).toFixed(0);
                _log(`[${file.name}] 压缩完成: ${originalSize}KB -> ${compressedSize}KB`);
            }
        }).catch(err => {
            _log(`[${file.name}] 压缩出错，将使用原图`, err);
            const item = State.selectedImageBlobs.find(x => x.id === itemId);
            if (item) {
                item.file = file; // Fallback to raw file
            }
        });
    });

    DOM.fileInput.value = '';
}

function renderPreviewGrid() {
    DOM.uploadPreviewGrid.innerHTML = '';
    
    if (State.selectedImageBlobs.length > 0) {
        DOM.uploadPrompt.classList.add('hidden');
        DOM.uploadPreviewGrid.classList.remove('hidden');

        State.selectedImageBlobs.forEach(item => {
            const container = document.createElement('div');
            container.className = 'upload-preview-item';
            
            container.innerHTML = `
                <img src="${item.previewUrl}" alt="预览">
                <button type="button" class="btn-remove-preview" onclick="handleRemovePreview(${item.id})" title="移除图片">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
            `;
            DOM.uploadPreviewGrid.appendChild(container);
        });
    } else {
        DOM.uploadPreviewGrid.classList.add('hidden');
        DOM.uploadPrompt.classList.remove('hidden');
    }
}

window.handleRemovePreview = function(id) {
    const index = State.selectedImageBlobs.findIndex(x => x.id === id);
    if (index !== -1) {
        URL.revokeObjectURL(State.selectedImageBlobs[index].previewUrl);
        State.selectedImageBlobs.splice(index, 1);
        renderPreviewGrid();
    }
};

function clearImageSelection() {
    DOM.fileInput.value = '';
    State.selectedImageBlobs.forEach(item => {
        URL.revokeObjectURL(item.previewUrl);
    });
    State.selectedImageBlobs = [];
    renderPreviewGrid();
}

/**
 * Compresses an image file client-side using HTML Canvas.
 */
function compressImage(file, maxDimension, quality) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = URL.createObjectURL(file);
        
        image.onload = () => {
            let width = image.width;
            let height = image.height;
            
            if (width > height) {
                if (width > maxDimension) {
                    height = Math.round((height * maxDimension) / width);
                    width = maxDimension;
                }
            } else {
                if (height > maxDimension) {
                    width = Math.round((width * maxDimension) / height);
                    height = maxDimension;
                }
            }
            
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            
            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, width, height);
            
            canvas.toBlob((blob) => {
                if (blob) {
                    resolve(blob);
                } else {
                    reject(new Error('Canvas to Blob failed'));
                }
            }, 'image/jpeg', quality);
            
            URL.revokeObjectURL(image.src);
        };
        
        image.onerror = (err) => {
            URL.revokeObjectURL(image.src);
            reject(err);
        };
    });
}

// --- Publishing ---
async function handlePublishSubmit() {
    const content = DOM.publishContent.value.trim();
    if (!content) return;
    if (content.length > 2000) {
        showToast('发布内容字数不能超过2000字', 'error');
        return;
    }

    if (!State.userToken) {
        openAuthModal('publish');
        return;
    }

    const uncompressedCount = State.selectedImageBlobs.filter(x => x.file === null).length;
    if (uncompressedCount > 0) {
        showToast(`图片还在压缩中，请稍候...`, 'info');
        return;
    }

    DOM.btnPublish.disabled = true;
    DOM.btnPublish.textContent = '发布中...';

    const formData = new FormData();
    formData.append('rawContent', content);
    
    State.selectedImageBlobs.forEach((item, index) => {
        if (item.file) {
            formData.append('images', item.file, `image_${index}.jpg`);
        }
    });

    try {
        const response = await fetch('/api/publish', {
            method: 'POST',
            headers: {
                'X-Token': State.userToken
            },
            body: formData
        });

        const data = await response.json();

        if (response.ok) {
            showToast('发布成功！', 'success');
            DOM.publishContent.value = '';
            clearImageSelection();
            State.pendingPublish = false;
            
            DOM.publishCard.classList.add('hidden');
            
            if (State.currentTab === 'all') {
                loadFeed(true);
            } else {
                switchTab('all');
            }
        } else if (response.status === 401 && data.code === 'NEED_AUTH') {
            showToast('管理权限失效，请重新进行验证', 'error');
            localStorage.removeItem('userToken');
            localStorage.removeItem('userPhone');
            State.userToken = null;
            State.userPhone = null;
            initUserBadge();
            openAuthModal('publish');
        } else {
            showToast(data.error || '发布失败', 'error');
        }
    } catch (err) {
        showToast('网络错误，发布失败，请稍后重试', 'error');
    } finally {
        DOM.btnPublish.disabled = false;
        DOM.btnPublish.textContent = '立即发布';
    }
}

function switchTab(tab) {
    if (State.currentTab === tab) return;
    
    State.currentTab = tab;
    updateSearchStatus();
    if (tab === 'my') {
        DOM.myFeedHeader.classList.remove('hidden');
        DOM.searchSection.classList.add('hidden');
    } else if (tab === 'pending') {
        DOM.myFeedHeader.classList.remove('hidden');
        updatePendingHeader();
        DOM.searchSection.classList.add('hidden');
    } else {
        DOM.myFeedHeader.classList.add('hidden');
        DOM.searchSection.classList.remove('hidden'); // Show search box in global feed
    }
    
    if (tab === 'pending' && State.isAdmin) {
        DOM.adminFilterTabs?.classList.remove('hidden');
        DOM.smsStatsPanel?.classList.remove('hidden');
        loadSmsStats();
    } else {
        DOM.adminFilterTabs?.classList.add('hidden');
    }

    loadFeed(true);
}

async function loadFeed(reset = false) {
    if (reset) {
        State.page = 1;
        State.records = [];
        State.hasMore = true;
        const hasVisibleRecords = DOM.feedGrid.querySelectorAll('.feed-card').length > 0;
        DOM.feedGrid.classList.toggle('is-refreshing', hasVisibleRecords);
        DOM.feedGrid.setAttribute('aria-busy', 'true');
        if (!hasVisibleRecords) {
            DOM.feedLoading.classList.remove('hidden');
        }
        updateSearchStatus(null, Boolean(State.searchQuery));
    } else {
        DOM.infiniteScrollLoader.classList.remove('hidden');
    }

    State.loading = true;
    DOM.feedEmpty.classList.add('hidden');

    try {
        let url = '';
        let headers = {};

        if (State.currentTab === 'my') {
            url = '/api/my-records';
            headers['X-Token'] = State.userToken || '';
        } else if (State.currentTab === 'pending') {
            url = `/api/records?status=${State.adminFilterStatus}&page=${State.page}&limit=${State.limit}`;
            if (State.userToken) headers['X-Token'] = State.userToken;
        } else {
            url = `/api/records?q=${encodeURIComponent(State.searchQuery)}&page=${State.page}&limit=${State.limit}`;
            // Always pass token so server knows who is viewing (for own-post visibility + admin)
            if (State.userToken) headers['X-Token'] = State.userToken;
        }

        const response = await fetch(url, { headers });
        let data;
        if (response.ok) {
            const text = await response.text();
            data = deobfuscate(text);
        } else {
            data = await response.json();
        }

        if (response.ok) {
            const items = State.currentTab === 'my' ? data.items : data.items;
            if (State.isAdmin && typeof data.pendingCount === 'number') {
                State.pendingCount = data.pendingCount;
                updatePendingButton();
                updatePendingHeader();
            }
            
            if (reset) {
                State.records = items;
            } else {
                State.records = State.records.concat(items);
            }

            renderFeed(items, reset);
            
            if (State.currentTab === 'all' || State.currentTab === 'pending') {
                State.hasMore = State.records.length < data.total;
            } else {
                State.hasMore = false;
            }

            if (State.records.length === 0) {
                DOM.feedEmpty.classList.remove('hidden');
                if (State.searchQuery && State.currentTab === 'all') {
                    renderSearchSuggestions();
                }
            }

            if (State.currentTab === 'all') {
                updateSearchStatus(data.total, false);
            }
        } else {
            if (State.currentTab === 'my' && response.status === 401) {
                DOM.feedEmpty.querySelector('h3').textContent = '未绑定设备权限';
                DOM.feedEmpty.querySelector('p').textContent = '请点击右上方“同步找回”验证手机号以管理我的发布。';
                DOM.feedEmpty.classList.remove('hidden');
            } else {
                showToast(data.error || '加载列表失败', 'error');
            }
        }
    } catch (err) {
        console.error('loadFeed error:', err);
        if (State.searchQuery && State.currentTab === 'all') {
            DOM.searchStatus.classList.remove('hidden');
            DOM.searchStatusText.textContent = `“${State.searchQuery}”搜索暂时失败，请稍后重试`;
        }
        showToast('加载失败，网络请求错误', 'error');
    } finally {
        State.loading = false;
        DOM.feedGrid.classList.remove('is-refreshing');
        DOM.feedGrid.removeAttribute('aria-busy');
        DOM.feedLoading.classList.add('hidden');
        DOM.infiniteScrollLoader.classList.add('hidden');
    }
}

function updateSearchStatus(total = null, loading = false) {
    if (!State.searchQuery || State.currentTab !== 'all') {
        DOM.searchStatus.classList.add('hidden');
        DOM.searchStatusText.textContent = '';
        return;
    }

    DOM.searchStatus.classList.remove('hidden');
    if (State.searchQuery.length < 2) {
        DOM.searchStatusText.textContent = `“${State.searchQuery}” · 再输入 1 个字开始搜索`;
    } else if (loading) {
        DOM.searchStatusText.textContent = `正在搜索“${State.searchQuery}”...`;
    } else if (typeof total === 'number') {
        DOM.searchStatusText.textContent = `“${State.searchQuery}”相关信息 ${total} 条`;
    } else {
        DOM.searchStatusText.textContent = `正在查看“${State.searchQuery}”的搜索结果`;
    }
}

// --- 首页曝光浏览计数 ---
// 卡片滚动进入视口即计一次"浏览"，每会话每条最多一次（sessionStorage 去重），批量上报
const viewedSession = new Set();
const viewQueue = new Set();
let viewTimer = null;
let feedObserver = null;
const VIEW_DEDUP_KEY = 'xilin_viewed_ids_v1';

function loadViewedSession() {
    try {
        const saved = sessionStorage.getItem(VIEW_DEDUP_KEY);
        if (saved) JSON.parse(saved).forEach(id => viewedSession.add(String(id)));
    } catch (e) { /* ignore */ }
}

function saveViewedSession() {
    try { sessionStorage.setItem(VIEW_DEDUP_KEY, JSON.stringify([...viewedSession])); } catch (e) { /* ignore */ }
}

function queueView(id) {
    if (viewedSession.has(String(id))) return;
    viewedSession.add(String(id));
    viewQueue.add(id);
    saveViewedSession();
    if (viewTimer) clearTimeout(viewTimer);
    viewTimer = setTimeout(flushViews, 1500);
}

async function flushViews() {
    viewTimer = null;
    if (viewQueue.size === 0) return;
    const ids = [...viewQueue];
    viewQueue.clear();
    try {
        await fetch('/api/records/views', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(ids)
        });
    } catch (e) { /* 静默失败，下次会话再计 */ }
}

function setupFeedObserver() {
    if (feedObserver) return;
    feedObserver = new IntersectionObserver((entries) => {
        entries.forEach(en => {
            if (en.isIntersecting) {
                const id = en.target.dataset.id;
                if (id) queueView(id);
                feedObserver.unobserve(en.target);
            }
        });
    }, { rootMargin: '0px 0px -10% 0px' });
}

function formatViewCount(n) {
    n = Number(n) || 0;
    if (n >= 10000) return (n / 10000).toFixed(1).replace(/\.0$/, '') + '万';
    return String(n);
}

loadViewedSession();
setupFeedObserver();

// --- JS 瀑布流分列管理 ---
// 卡片固定分配到最矮的列，追加新卡片不会移动已有卡片（解决 CSS columns 滚动时整列重排跳动的问题）
let feedCols = [];
let feedColCount = 0;

function getFeedColCount() {
    return 1; // 单列列表，一行一个卡片
}

function initFeedColumns(reset) {
    const count = getFeedColCount();
    if (reset || feedCols.length !== count) {
        DOM.feedGrid.innerHTML = '';
        feedCols = [];
        feedColCount = count;
        for (let i = 0; i < count; i++) {
            const col = document.createElement('div');
            col.className = 'feed-col';
            DOM.feedGrid.appendChild(col);
            feedCols.push(col);
        }
    }
}

function getShortestCol() {
    let idx = 0;
    let minH = Infinity;
    feedCols.forEach((col, i) => {
        const h = col.offsetHeight;
        if (h < minH) { minH = h; idx = i; }
    });
    return feedCols[idx];
}

// 窗口宽度变化导致列数变化时，重建瀑布流
let masonryResizeTimer = null;
window.addEventListener('resize', () => {
    clearTimeout(masonryResizeTimer);
    masonryResizeTimer = setTimeout(() => {
        if (getFeedColCount() !== feedColCount) {
            loadFeed(true);
        }
    }, 250);
});

function renderFeed(newItems, reset) {
    initFeedColumns(reset);

    newItems.forEach(item => {
        const card = document.createElement('div');
        card.className = 'feed-card';
        card.dataset.id = item.id;

        // SEO: Generate meaningful alt text from content
        const altText = (item.rawContent || '').replace(/[<>"'&]/g, '').substring(0, 80).trim() || '锡林网本地信息图片';
        const displayTitle = item.title || generateTitleFromContent(item.rawContent);

        // 封面：有图显示图片（固定高度裁切）；无图不显示图。标题下方都显示摘要
        let imageHtml = '';
        let summaryHtml = '';
        const images = item.imageUrl ? item.imageUrl.split(',').filter(x => x.trim().length > 0) : [];
        if (images.length > 0) {
            imageHtml = `
                <a class="feed-card-cover" href="/p/${item.id}" title="${escapeStringForAttr(displayTitle)}">
                    <img src="${images[0]}" alt="${altText}" loading="lazy">
                    ${images.length > 1 ? `<span class="feed-img-count">${images.length}图</span>` : ''}
                </a>
            `;
        }
        if (item.rawContent) {
            summaryHtml = `<div class="feed-card-summary">${escapeHtml(convertWeChatEmoji(item.rawContent))}</div>`;
        }

        // Status badge is shown to the post owner if not Approved
        let statusBadgeHtml = '';
        if (item.isOwn && item.status && item.status !== 'Approved') {
            const isPending = item.status === 'Pending';
            statusBadgeHtml = `<span class="review-badge ${isPending ? 'badge-pending' : 'badge-rejected'}">${isPending ? '⏳ AI 审核中' : '❌ 未通过'}</span>`;
        }

        // Action Section：编辑/删除只在"我的"页面显示，另起一行，首页不显示
        let actionHtml = '';
        if (State.currentTab === 'my') {
            actionHtml = `
                <div class="feed-card-actions">
                    <button class="btn-edit" onclick="handleEditRecord(${item.id})" title="编辑">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:0.85rem;height:0.85rem;"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                        编辑
                    </button>
                    <button class="btn-delete" onclick="handleDeleteRecord(${item.id})">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:0.85rem;height:0.85rem;"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
                        删除
                    </button>
                </div>
            `;
        }
        card.innerHTML = `
            ${imageHtml}
            <div class="feed-card-body">
                ${statusBadgeHtml}
                <h2 class="feed-card-title"><a href="/p/${item.id}">${escapeHtml(displayTitle)}</a></h2>
                ${summaryHtml}
                <div class="feed-card-footer">
                    <div class="feed-card-time">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:0.85rem;height:0.85rem;"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        <span>${formatRelativeTime(item.createTime)}</span>
                    </div>
                    <div style="display: flex; gap: 8px; align-items: center;">
                        <span class="feed-view-count"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="width:0.85rem;height:0.85rem;"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>${formatViewCount(item.viewCount)}</span>
                    </div>
                </div>
                ${actionHtml}
            </div>
        `;
        
        // 整卡可点：点击卡片任意位置（除内部链接/按钮外）进入详情页
        card.addEventListener('click', (e) => {
            if (e.target.closest('a, button')) return; // 内部链接/按钮自行处理
            window.location.href = `/p/${item.id}`;
        });

        // 曝光浏览计数：卡片进入视口即上报一次（每会话每条只计一次）
        if (feedObserver) feedObserver.observe(card);

        getShortestCol().appendChild(card);
    });
}

function generateTitleFromContent(content) {
    const text = (content || '').replace(/\s+/g, ' ').trim();
    if (!text) return '锡林网信息';
    return text.length > 18 ? `${text.slice(0, 18)}...` : text;
}

// --- Deletion ---
function showDeleteConfirm() {
    return new Promise((resolve) => {
        const overlay = document.getElementById('delete-confirm-overlay');
        const okBtn = document.getElementById('delete-ok-btn');
        const cancelBtn = document.getElementById('delete-cancel-btn');
        overlay.classList.remove('hidden');
        const cleanup = (result) => {
            overlay.classList.add('hidden');
            okBtn.removeEventListener('click', onOk);
            cancelBtn.removeEventListener('click', onCancel);
            resolve(result);
        };
        const onOk = () => cleanup(true);
        const onCancel = () => cleanup(false);
        okBtn.addEventListener('click', onOk);
        cancelBtn.addEventListener('click', onCancel);
    });
}

window.handleDeleteRecord = async function(id) {
    const confirmed = await showDeleteConfirm();
    if (!confirmed) return;

    try {
        const response = await fetch(`/api/records/${id}`, {
            method: 'DELETE',
            headers: {
                'X-Token': State.userToken || ''
            }
        });

        const data = await response.json();

        if (response.ok) {
            showToast('删除成功', 'success');
            if (State.isAdmin && State.currentTab === 'pending') {
                State.pendingCount = Math.max(0, State.pendingCount - 1);
                updatePendingButton();
                updatePendingHeader();
            }
            State.records = State.records.filter(r => r.id !== id);
            const card = DOM.feedGrid.querySelector(`[data-id="${id}"]`);
            if (card) {
                card.style.animation = 'zoomIn 0.3s reverse forwards';
                setTimeout(() => card.remove(), 300);
            }
            if (State.records.length === 0) {
                DOM.feedEmpty.classList.remove('hidden');
            }
        } else {
            showToast(data.error || '删除失败', 'error');
        }
    } catch (err) {
        showToast('网络错误，删除失败', 'error');
    }
};

// --- Admin Review ---
window.handleReview = async function(id, action) {
    try {
        const response = await fetch(`/api/records/${id}/review`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-Token': State.userToken || ''
            },
            body: JSON.stringify({ action })
        });

        const data = await response.json();

        if (response.ok) {
            showToast(action === 'approve' ? '✅ 已通过' : '❌ 已设为不通过', 'success');
            if (State.currentTab === 'pending') {
                State.pendingCount = Math.max(0, State.pendingCount - 1);
                updatePendingButton();
                updatePendingHeader();
            }
            // Update card buttons in place
            const card = DOM.feedGrid.querySelector(`[data-id="${id}"]`);
            if (card) {
                if (State.currentTab === 'pending') {
                    card.style.transition = 'all 0.3s ease';
                    card.style.opacity = '0';
                    card.style.transform = 'scale(0.9)';
                    setTimeout(() => {
                        card.remove();
                        if (DOM.feedGrid.querySelectorAll('.feed-card').length === 0) {
                            DOM.feedEmpty.classList.remove('hidden');
                        }
                    }, 300);
                } else {
                    const approveBtn = card.querySelector('.btn-approve');
                    const rejectBtn = card.querySelector('.btn-reject');
                    if (approveBtn) approveBtn.classList.toggle('active', action === 'approve');
                    if (rejectBtn) rejectBtn.classList.toggle('active', action === 'reject');
                    // Update or remove status badge
                    let badge = card.querySelector('.review-badge');
                    if (action === 'approve') {
                        if (badge) badge.remove();
                    } else {
                        if (!badge) {
                            badge = document.createElement('span');
                            badge.className = 'review-badge badge-rejected';
                            card.querySelector('.feed-card-body').prepend(badge);
                        }
                        badge.className = 'review-badge badge-rejected';
                        badge.textContent = '❌ 未通过';
                    }
                }
            }
        } else {
            showToast(data.error || '审核操作失败', 'error');
        }
    } catch (err) {
        showToast('网络错误，审核失败', 'error');
    }
};


// --- Lightbox / Image Viewer ---
window.openLightbox = function(imagesData, index = 0) {
    if (typeof imagesData === 'string') {
        State.lightboxImages = imagesData.split(',').filter(x => x.trim().length > 0);
    } else if (Array.isArray(imagesData)) {
        State.lightboxImages = imagesData;
    } else {
        State.lightboxImages = [];
    }
    
    State.lightboxIndex = parseInt(index) || 0;
    
    updateLightboxDisplay();
    DOM.imageModal.classList.remove('hidden');
};

function updateLightboxDisplay() {
    if (State.lightboxImages.length === 0) return;
    
    // Automatically reset zoom scales/coordinates for the new image
    if (State.resetZoom) {
        State.resetZoom();
    }
    
    DOM.lightboxImg.src = State.lightboxImages[State.lightboxIndex];
    DOM.lightboxCounter.textContent = `${State.lightboxIndex + 1} / ${State.lightboxImages.length}`;

    if (State.lightboxImages.length <= 1) {
        DOM.btnPrevImage.classList.add('hidden');
        DOM.btnNextImage.classList.add('hidden');
        DOM.lightboxCounter.classList.add('hidden');
    } else {
        DOM.btnPrevImage.classList.remove('hidden');
        DOM.btnNextImage.classList.remove('hidden');
        DOM.lightboxCounter.classList.remove('hidden');
    }
}

function navigateLightbox(direction) {
    if (State.lightboxImages.length <= 1) return;
    State.lightboxIndex = (State.lightboxIndex + direction + State.lightboxImages.length) % State.lightboxImages.length;
    updateLightboxDisplay();
}

// --- Toast System ---
function showToast(message, type = 'info') {
    const toast = document.createElement('div');
    toast.className = 'el-message';
    const icons = {
        success: '<svg viewBox="0 0 24 24" fill="none" stroke="#67c23a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>',
        warning: '<svg viewBox="0 0 24 24" fill="none" stroke="#e6a23c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',
        error: '<svg viewBox="0 0 24 24" fill="none" stroke="#f56c6c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>',
        info: '<svg viewBox="0 0 24 24" fill="none" stroke="#909399" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>'
    };
    toast.innerHTML = `${icons[type] || icons.info}<span>${message}</span>`;
    DOM.toastContainer.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('el-message-show'));
    setTimeout(() => {
        toast.classList.add('el-message-leave');
        setTimeout(() => toast.remove(), 300);
    }, 3000);
}

// --- Utilities ---
function maskPhoneNumber(phone) {
    if (phone.length !== 11) return phone;
    return `${phone.substring(0, 3)}****${phone.substring(7)}`;
}

function escapeHtml(string) {
    return String(string)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function escapeStringForAttr(string) {
    return String(string).replace(/'/g, "\\'");
}

// 摘要文本中隐藏手机号（连同"电话/联系电话"等前缀一起删除，避免留下孤零零的"电话"）
function stripPhoneFromText(text) {
    return String(text || '')
        .replace(/(联系电话|联系方式|联系|手机|电话)?\s*[：:]?\s*1[3-9]\d[\s-]*\d{4}[\s-]*\d{4}/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
}

// 微信表情代码转 emoji（支持 [庆祝] 和 ［庆祝］ 全角括号）
const WECHAT_EMOJI = {
    "[微笑]":"😊","[强]":"💪","[抱拳]":"🙏","[庆祝]":"🎉","[OK]":"👌","[握手]":"🤝","[胜利]":"✌️","[爱心]":"❤️","[咖啡]":"☕","[抱抱]":"🤗",
    "[加油]":"💪","[耶]":"✌️","[鼓掌]":"👏","[玫瑰]":"🌹","[太阳]":"☀️","[月亮]":"🌙","[星星]":"⭐","[红包]":"🧧","[旺]":"🔥","[赞]":"👍",
    "[汗]":"😅","[尴尬]":"😅","[难过]":"😢","[大哭]":"😭","[惊讶]":"😮","[发抖]":"🥶","[跳跳]":"💃","[可爱]":"🥰","[皱眉]":"😣","[奸笑]":"😏",
    "[捂脸]":"🤦","[嘿哈]":"😄","[机智]":"🤓","[调皮]":"😜","[呲牙]":"😁","[得意]":"😎","[害羞]":"😊","[偷笑]":"🤭","[发呆]":"😶","[疯了]":"🤪",
    "[心碎]":"💔","[凋谢]":"🥀","[礼物]":"🎁","[蛋糕]":"🎂","[啤酒]":"🍺","[干杯]":"🥂","[烟花]":"🎆","[爆竹]":"🧨","[福]":"🧧","[发]":"💰",
    "[转圈]":"💫","[敲打]":"🔨","[再见]":"👋","[惊恐]":"😨","[冷汗]":"😰","[勾引]":"👉"
};

function convertWeChatEmoji(text) {
    let t = String(text || '')
        .replace(/［/g, '[').replace(/］/g, ']')
        .replace(/【/g, '[').replace(/】/g, ']');
    for (const key in WECHAT_EMOJI) {
        t = t.split(key).join(WECHAT_EMOJI[key]);
    }
    return t;
}

function formatContent(rawContent, searchQuery) {
    let html = escapeHtml(rawContent);

    // 1. URL Link Auto-detection
    const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    html = html.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-link">$1</a>');

    // 2. Chinese Mobile Number Auto-detection (supports spaces/dashes like 152 4952 8172)
    const phoneRegex = /(1[3-9]\d[\s-]*\d{4}[\s-]*\d{4})/g;
    html = html.replace(phoneRegex, (match) => {
        const cleanPhone = match.replace(/[\s-]/g, '');
        return `<a href="tel:${cleanPhone}" class="phone-link">${match}</a>`;
    });

    // 2.5. Hashtag Auto-detection (e.g. #招聘, #租房)
    const hashtagRegex = /#([a-zA-Z0-9\u4e00-\u9fa5]{2,10})/g;
    html = html.replace(hashtagRegex, '<span class="hashtag" onclick="handleHashtagClick(\'$1\', event)" style="color: var(--primary); background: rgba(59, 130, 246, 0.08); padding: 2px 6px; border-radius: 4px; font-weight: 600; cursor: pointer; margin-right: 4px; display: inline-block; font-size: 0.85rem; border: 1px solid rgba(59, 130, 246, 0.12); transition: all 0.2s;">#$1</span>');

    // 2.7. WeChat text emoji parsing (e.g. [抱拳])
    const wechatEmojiMap = {
        '抱拳': '🙏', '微笑': '😊', '呲牙': '😁', '大拇指': '👍', '强': '👍', '弱': '👎', 'OK': '👌',
        '握手': '🤝', '爱心': '❤️', '心碎': '💔', '玫瑰': '🌹', '咖啡': '☕', '太阳': '☀️', '月亮': '🌙',
        '拥抱': '🤗', '叹气': '😮‍💨', '流泪': '😭', '泪': '😭', '害羞': '😊', '发怒': '😡', '疑问': '❓',
        '调皮': '😜', '得意': '😎', '偷笑': '🤭', '再见': '👋', '胜利': '✌️', '拳头': '✊', '加油': '✊',
        '生病': '😷', '吐': '🤮', '笑哭': '😂', '嘘': '🤫', '白眼': '🙄', '撇嘴': '😕', '委屈': '🥺',
        '抠鼻': '👃', '坏笑': '😏', '惊讶': '😱', '难过': '😢', '酷': '😎', '汗': '😅', '捂脸': '🤦',
        '憨笑': '😃', '发呆': '😳', '尴尬': '😅', '冷汗': '😰', '抓狂': '😫', '流鼻血': '👃', '哈欠': '🥱',
    
        '炎花': '🎆',
        '爆竹': '🧨',
        '红包': '🧧',
        '福': '🎆',
        '祝福': '🎉',
        '庆祝': '🎉',
        '蛋糕': '🎂',
        '生日': '🎂',
        '礼物': '🎁',
        '饮料': '🥤',
        '小动物': '🐱',
        '狗': '🐶',
        '猫': '🐱',
        '饮酒': '🍺',
        '汽车': '🚗',
        '飞机': '✈️',
        '火车': '🚄',
        '手机': '📱',
        '钱': '💰',
        '目标': '🎯',
        '春连': '🎉',
        '登录': '👤',
        '工具': '🔧',
        '信息': 'ℹ️',
        '打卡': '✅',
};
    html = html.replace(/\[([^\]]{1,10})\]/g, (match, tag) => {
        if (wechatEmojiMap[tag]) {
            return `<span class="wechat-emoji" title="${tag}" style="font-family: 'Apple Color Emoji', 'Segoe UI Emoji', 'Noto Color Emoji', sans-serif; font-size: 1.15em; vertical-align: middle; line-height: 1; margin: 0 2px;">${wechatEmojiMap[tag]}</span>`;
        }
        return match;
    });

    // 3. Search Term Highlight
    if (searchQuery) {
        const terms = searchQuery.split(/[\s,，]+/).filter(x => x.trim().length > 0);
        terms.forEach(term => {
            const escapedTerm = term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            // Matches term but ignores content inside HTML tags (like link hrefs or tag names)
            const highlightRegex = new RegExp('(' + escapedTerm + ')(?![^<>]*>)', 'gi');
            html = html.replace(highlightRegex, '<mark class="highlight">$1</mark>');
        });
    }

    return html;
}

function formatRelativeTime(dateStr) {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHr = Math.floor(diffMin / 60);
    const diffDays = Math.floor(diffHr / 24);

    if (diffSec < 60) {
        return '刚刚';
    } else if (diffMin < 60) {
        return `${diffMin}分钟前`;
    } else if (diffHr < 24) {
        return `${diffHr}小时前`;
    } else if (diffDays === 1) {
        return '昨天';
    } else if (diffDays === 2) {
        return '前天';
    } else if (diffDays < 30) {
        return `${diffDays}天前`;
    } else {
        return date.toLocaleDateString('zh-CN', { month: 'short', day: 'numeric' });
    }
}

function _log(...args) {
    console.log('[LocalLife]', ...args);
}

// --- Admin Edit Modal Functions ---
let editExistingImages = [];
let editNewFiles = [];

window.handleEditRecord = function(id) {
    const item = State.records.find(r => r.id === id);
    if (!item) {
        showToast('找不到信息记录', 'error');
        return;
    }

    // Populate modal fields
    DOM.editRecordId.value = item.id;
    DOM.editContent.value = item.rawContent;
    
    // Parse existing images
    editExistingImages = item.imageUrl ? item.imageUrl.split(',').filter(x => x.trim().length > 0) : [];
    editNewFiles = []; // Reset new uploaded files
    DOM.editFileInput.value = ''; // Reset file input

    // Render existing images grid
    renderEditExistingImages();
    
    // Render new images preview (should be empty initially)
    renderEditNewPreview();

    // Show modal
    DOM.editModal.classList.remove('hidden');
};

function renderEditExistingImages() {
    DOM.editExistingImagesGrid.innerHTML = '';
    if (editExistingImages.length === 0) {
        DOM.editExistingImagesGrid.innerHTML = '<span style="color: var(--text-muted); font-size: 0.85rem; grid-column: span 4;">暂无图片</span>';
        return;
    }

    editExistingImages.forEach((imgUrl, idx) => {
        const itemDiv = document.createElement('div');
        itemDiv.className = 'upload-preview-item';
        itemDiv.style.position = 'relative';
        itemDiv.style.aspectRatio = '1';
        itemDiv.style.borderRadius = '8px';
        itemDiv.style.overflow = 'hidden';

        itemDiv.innerHTML = `
            <img src="${imgUrl}" alt="现有图片" style="width: 100%; height: 100%; object-fit: cover;">
            <button type="button" class="btn-remove-preview" onclick="handleRemoveExistingImg(${idx})" title="删除图片" style="position: absolute; top: 4px; right: 4px; border: none; background: rgba(239, 68, 68, 0.85); color: white; border-radius: 50%; width: 20px; height: 20px; font-size: 10px; cursor: pointer; display: flex; align-items: center; justify-content: center;">✕</button>
        `;
        DOM.editExistingImagesGrid.appendChild(itemDiv);
    });
}

window.handleRemoveExistingImg = function(index) {
    editExistingImages.splice(index, 1);
    renderEditExistingImages();
};

function handleEditFileSelect(e) {
    const files = e.target.files;
    if (files && files.length > 0) {
        const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const ext = file.name.split('.').pop().toLowerCase();
            if (!allowedExtensions.includes(ext)) {
                showToast(`不支持的文件格式: .${ext}`, 'error');
                continue;
            }
            if (file.size > 5 * 1024 * 1024) {
                showToast(`图片不能超过5MB: ${file.name}`, 'error');
                continue;
            }
            if (editExistingImages.length + editNewFiles.length >= 9) {
                showToast('最多只能上传9张图片', 'warning');
                break;
            }
            editNewFiles.push(file);
        }
        renderEditNewPreview();
    }
}

function renderEditNewPreview() {
    DOM.editUploadPreviewGrid.innerHTML = '';
    if (editNewFiles.length === 0) {
        DOM.editUploadPreviewGrid.classList.add('hidden');
        DOM.editUploadZone.querySelector('.upload-prompt').classList.remove('hidden');
        return;
    }

    DOM.editUploadPreviewGrid.classList.remove('hidden');
    DOM.editUploadZone.querySelector('.upload-prompt').classList.add('hidden');

    editNewFiles.forEach((file, idx) => {
        const reader = new FileReader();
        const itemDiv = document.createElement('div');
        itemDiv.className = 'upload-preview-item';
        itemDiv.style.position = 'relative';
        itemDiv.style.aspectRatio = '1';
        itemDiv.style.borderRadius = '8px';
        itemDiv.style.overflow = 'hidden';

        reader.onload = (e) => {
            itemDiv.innerHTML = `
                <img src="${e.target.result}" alt="预览" style="width: 100%; height: 100%; object-fit: cover;">
                <button type="button" class="btn-remove-preview" onclick="handleRemoveEditNewImg(${idx})" title="移除" style="position: absolute; top: 4px; right: 4px; border: none; background: rgba(239, 68, 68, 0.85); color: white; border-radius: 50%; width: 20px; height: 20px; font-size: 10px; cursor: pointer; display: flex; align-items: center; justify-content: center;">✕</button>
            `;
        };
        reader.readAsDataURL(file);
        DOM.editUploadPreviewGrid.appendChild(itemDiv);
    });
}

window.handleRemoveEditNewImg = function(index) {
    editNewFiles.splice(index, 1);
    renderEditNewPreview();
};

window.closeEditModal = function() {
    DOM.editModal.classList.add('hidden');
};

async function handleEditFormSubmit() {
    const id = DOM.editRecordId.value;
    const rawContent = DOM.editContent.value.trim();
    if (!rawContent) {
        showToast('内容不能为空', 'warning');
        return;
    }
    if (rawContent.length > 2000) {
        showToast('修改内容字数不能超过2000字', 'error');
        return;
    }

    const btnSubmit = DOM.editForm.querySelector('button[type="submit"]');
    const originalText = btnSubmit.textContent;
    btnSubmit.disabled = true;
    btnSubmit.textContent = '保存中...';

    try {
        const formData = new FormData();
        formData.append('rawContent', rawContent);
        formData.append('existingImages', editExistingImages.join(','));

        // Append new images
        editNewFiles.forEach(file => {
            formData.append('images', file);
        });

        const response = await fetch(`/api/admin/edit-record/${id}`, {
            method: 'POST',
            headers: {
                'X-Token': State.userToken || ''
            },
            body: formData
        });

        const data = await response.json();
        if (response.ok) {
            showToast('修改成功！关键字正在重新提取中', 'success');
            closeEditModal();
            // Refresh feed
            loadFeed(true);
        } else {
            showToast(data.error || '保存修改失败', 'error');
        }
    } catch (err) {
        showToast('网络错误，修改失败', 'error');
    } finally {
        btnSubmit.disabled = false;
        btnSubmit.textContent = originalText;
    }
}

async function handleBackupClick() {
    const ok = await showConfirm('确定要立即备份数据库吗？（备份过程大约需要 1-3 秒，备份文件将保存在服务器上 C:\\db_backups\\ 文件夹中）');
    if (!ok) return;

    const btnBackup = DOM.btnFeedBackup;
    const originalText = btnBackup.textContent;
    btnBackup.disabled = true;
    btnBackup.textContent = '备份中...';

    try {
        const response = await fetch('/api/admin/backup-db', {
            method: 'POST',
            headers: {
                'X-Token': State.userToken || ''
            }
        });

        const data = await response.json();
        if (response.ok) {
            showToast('数据库备份成功！已安全保存至服务器。', 'success');
        } else {
            showToast(data.error || '数据库备份失败', 'error');
        }
    } catch (err) {
        showToast('网络错误，备份触发失败', 'error');
    } finally {
        btnBackup.disabled = false;
        btnBackup.textContent = originalText;
    }
}

window.handleHashtagClick = function(tag, event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }
    
    if (State.currentTab !== 'all') {
        switchTab('all');
    }
    
    DOM.searchInput.value = tag;
    State.searchQuery = tag;
    DOM.btnClearSearch.classList.remove('hidden');
    updateSearchStatus(null, true);
    addSearchHistory(tag);

    loadFeed(true);
    
    // Update URL and title for shareability
    const newUrl = `${window.location.pathname}?q=${encodeURIComponent(tag)}`;
    history.replaceState(null, '', newUrl);
    document.title = `${tag} - 锡林网搜索结果 | 锡林浩特本地生活信息`;
};

window.handleHotKeywordClick = function(kw) {
    if (State.currentTab !== 'all') {
        switchTab('all');
    }
    DOM.searchInput.value = kw;
    State.searchQuery = kw;
    DOM.btnClearSearch.classList.remove('hidden');
    updateSearchStatus(null, true);
    addSearchHistory(kw);
    loadFeed(true);
    const newUrl = `${window.location.pathname}?q=${encodeURIComponent(kw)}`;
    history.replaceState(null, '', newUrl);
    document.title = `${kw} - 锡林网搜索结果 | 锡林浩特本地生活信息`;
    const searchOffset = DOM.searchSection.offsetTop;
    window.scrollTo({ top: searchOffset, behavior: 'smooth' });
};

async function handleCopySummaryClick() {
    const btn = DOM.btnFeedCopySummary;
    if (!btn) return;
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '生成中...';

    try {
        const response = await fetch('/api/records/today-summary');
        if (!response.ok) {
            throw new Error('获取快报数据失败');
        }
        const data = await response.json();
        
        if (!data || data.totalCount === 0) {
            showToast('24小时内（或数据库中）暂无审核通过的信息，无法生成快报。', 'warning');
            return;
        }

        const dateStr = data.summaryDate;
        const total = data.totalCount;
        let text = `📅 【锡林网】24小时快报 · ${dateStr}\n`;
        
        if (data.isFallback) {
            text = `📅 【锡林网】最新信息汇总 · ${dateStr}\n`;
        }
        
        text += `━━━━━━━━━━━━━━━━━━━\n`;
        
        if (total <= 8) {
            // List all items
            let index = 1;
            data.groups.forEach(g => {
                text += `${g.emoji} [${g.categoryName}]\n`;
                g.items.forEach(item => {
                    const title = item.title || (item.rawContent.length > 25 ? item.rawContent.substring(0, 25) + '...' : item.rawContent);
                    text += `${index}. ${title.trim()}\n   👉 详情：https://xx.xilinhot.com/p/${item.id}\n`;
                    index++;
                });
                text += `\n`;
            });
            text = text.trim() + `\n`;
        } else {
            // Count summaries and item previews
            text += `24小时快报已累计更新 ${total} 条本地生活信息！\n\n`;
            
            data.groups.forEach(g => {
                const previews = g.items.slice(0, 3).map(item => {
                    const t = item.title || item.rawContent;
                    return t.length > 8 ? t.substring(0, 8) + '...' : t;
                }).join('、');
                text += `${g.emoji} [${g.categoryName}] 新增 ${g.items.length} 条 (${previews}...)\n`;
            });
            
            text += `━━━━━━━━━━━━━━━━━━━\n`;
            text += `🔥 最新精选：\n`;
            
            // Get the first 3 items across groups
            let featuredCount = 0;
            let index = 1;
            for (let i = 0; i < data.groups.length && featuredCount < 3; i++) {
                const g = data.groups[i];
                for (let j = 0; j < g.items.length && featuredCount < 3; j++) {
                    const item = g.items[j];
                    const title = item.title || (item.rawContent.length > 25 ? item.rawContent.substring(0, 25) + '...' : item.rawContent);
                    text += `${index}. ${title.trim()}\n`;
                    index++;
                    featuredCount++;
                }
            }
            
            text += `\n👇 点击链接查看全部 ${total} 条详细内容（支持一键拨号）：\n`;
            text += `🔗 https://xx.xilinhot.com/today\n`;
        }
        
        text += `━━━━━━━━━━━━━━━━━━━\n`;
        text += `💡 更多本地招聘、房产、闲置信息，欢迎访问：https://xx.xilinhot.com/`;

        try {
            await navigator.clipboard.writeText(text);
        } catch {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
        showToast('快报文本已成功复制到剪贴板，可直接粘贴发群！', 'success');
    } catch (err) {
        console.error('Copy summary error:', err);
        showToast('生成快报失败，请稍后重试', 'error');
    } finally {
        btn.disabled = false;
        btn.textContent = originalText;
    }
}

// --- SMS Stats (Admin Dashboard) ---
async function loadSmsStats() {
    if (!State.isAdmin || !State.userToken) return;
    try {
        const response = await fetch('/api/admin/sms-stats', {
            headers: { 'X-Token': State.userToken }
        });
        if (!response.ok) return;
        const stats = await response.json();
        if (DOM.smsStatTotal) DOM.smsStatTotal.textContent = stats.todayTotal + ' 条';
        if (DOM.smsStatSuccess) DOM.smsStatSuccess.textContent = stats.todaySuccess;
        if (DOM.smsStatFailed) DOM.smsStatFailed.textContent = stats.todayFailed;
        if (DOM.smsFailuresList && stats.recentFailures && stats.recentFailures.length > 0) {
            let html = '';
            stats.recentFailures.forEach(f => {
                const time = new Date(f.createTime).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' });
                const phone = f.phone.slice(0, 3) + '****' + f.phone.slice(7);
                html += '<div style="padding:4px 0;border-bottom:1px solid var(--border-color);color:var(--text-secondary);">'
                    + '<span>' + time + '</span> <span>' + phone + '</span> '
                    + '<span style="color:#ef4444;">' + (f.errorCode || '') + ' ' + (f.errorMessage || '') + '</span>'
                    + '</div>';
            });
            DOM.smsFailuresList.innerHTML = html;
        }
    } catch (e) {
        // Silently ignore
    }
}

function toggleSmsDetail() {
    if (!DOM.smsFailuresList) return;
    const hidden = DOM.smsFailuresList.classList.toggle('hidden');
    if (DOM.btnSmsDetail) DOM.btnSmsDetail.textContent = hidden ? '详情' : '收起';
}

// ==========================================================================
// Draft Auto-Save / Restore
// ==========================================================================
const DRAFT_KEY = 'publish_draft';

function restoreDraft() {
    try {
        const saved = localStorage.getItem(DRAFT_KEY);
        if (saved && DOM.publishContent) {
            DOM.publishContent.value = saved;
        }
    } catch (e) { /* ignore */ }
}

function saveDraft() {
    try {
        const content = DOM.publishContent?.value || '';
        if (content.trim()) {
            localStorage.setItem(DRAFT_KEY, content);
        } else {
            localStorage.removeItem(DRAFT_KEY);
        }
    } catch (e) { /* ignore */ }
}

function clearDraft() {
    try { localStorage.removeItem(DRAFT_KEY); } catch (e) { /* ignore */ }
}

// ==========================================================================
// Search History
// ==========================================================================
const SEARCH_HISTORY_KEY = 'search_history';
const MAX_SEARCH_HISTORY = 20;

function getSearchHistory() {
    try {
        return JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || '[]');
    } catch (e) { return []; }
}

function addSearchHistory(query) {
    if (!query || query.length < 2) return;
    try {
        let history = getSearchHistory();
        history = history.filter(h => h !== query);
        history.unshift(query);
        if (history.length > MAX_SEARCH_HISTORY) history.pop();
        localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
    } catch (e) { /* ignore */ }
}

function renderSearchSuggestions() {
    const history = getSearchHistory();
    if (history.length === 0) return;

    const existing = DOM.feedEmpty.querySelector('.search-suggestions');
    if (existing) existing.remove();

    const container = document.createElement('div');
    container.className = 'search-suggestions';
    container.style.cssText = 'margin-top:16px;text-align:center;';

    const label = document.createElement('p');
    label.textContent = '🔍 最近搜索';
    label.style.cssText = 'color:var(--text-muted);font-size:0.8rem;margin-bottom:8px;';
    container.appendChild(label);

    const tagsWrap = document.createElement('div');
    tagsWrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;justify-content:center;';

    history.slice(0, 8).forEach(h => {
        const tag = document.createElement('span');
        tag.textContent = h;
        tag.style.cssText = 'background:var(--bg-card, #fff);color:var(--text-secondary);padding:4px 12px;border-radius:20px;cursor:pointer;font-size:0.82rem;border:1px solid var(--border-color);transition:all 0.2s;';
        tag.addEventListener('click', () => {
            DOM.searchInput.value = h;
            State.searchQuery = h;
            DOM.btnClearSearch.classList.remove('hidden');
            updateSearchStatus(null, true);
            loadFeed(true);
            const newUrl = `${window.location.pathname}?q=${encodeURIComponent(h)}`;
            history.replaceState(null, '', newUrl);
            document.title = `${h} - 锡林网搜索结果 | 锡林浩特本地生活信息`;
        });
        tag.addEventListener('mouseenter', () => { tag.style.borderColor = 'var(--primary)'; tag.style.color = 'var(--primary)'; });
        tag.addEventListener('mouseleave', () => { tag.style.borderColor = 'var(--border-color)'; tag.style.color = 'var(--text-secondary)'; });
        tagsWrap.appendChild(tag);
    });
    container.appendChild(tagsWrap);
    DOM.feedEmpty.appendChild(container);
}

// ==========================================================================
// Upload Progress Bar
// ==========================================================================
function createProgressBar() {
    const bar = document.createElement('div');
    bar.className = 'upload-progress-bar';
    bar.style.cssText = 'width:100%;height:6px;background:var(--border-color);border-radius:3px;margin-top:10px;overflow:hidden;';
    const fill = document.createElement('div');
    fill.className = 'upload-progress-fill';
    fill.style.cssText = 'height:100%;width:0%;background:var(--primary);border-radius:3px;transition:width 0.15s ease;';
    bar.appendChild(fill);
    return { bar, fill };
}

// ==========================================================================
// Modified publish with upload progress (overrides original fetch-based submit)
// The bindEvents still calls handlePublishSubmit, which we override below.
// ==========================================================================
const _originalHandlePublishSubmit = handlePublishSubmit;

handlePublishSubmit = async function() {
    const content = DOM.publishContent.value.trim();
    if (!content) return;
    if (content.length > 2000) {
        showToast('发布内容字数不能超过2000字', 'error');
        return;
    }

    if (!State.userToken) {
        openAuthModal('publish');
        return;
    }

    const uncompressedCount = State.selectedImageBlobs.filter(x => x.file === null).length;
    if (uncompressedCount > 0) {
        showToast(`图片还在压缩中，请稍候...`, 'info');
        return;
    }

    DOM.btnPublish.disabled = true;
    DOM.btnPublish.textContent = '发布中...';

    const formData = new FormData();
    formData.append('rawContent', content);

    State.selectedImageBlobs.forEach((item, index) => {
        if (item.file) {
            formData.append('images', item.file, `image_${index}.jpg`);
        }
    });

    // Show progress bar if there are images
    let progBar = null;
    if (State.selectedImageBlobs.length > 0) {
        const pb = createProgressBar();
        progBar = pb;
        const footer = DOM.publishForm.querySelector('.publish-footer');
        if (footer) footer.parentNode.insertBefore(pb.bar, footer);
    }

    try {
        const xhr = new XMLHttpRequest();

        const response = await new Promise((resolve, reject) => {
            xhr.upload.addEventListener('progress', (e) => {
                if (e.lengthComputable && progBar) {
                    const pct = Math.round((e.loaded / e.total) * 100);
                    progBar.fill.style.width = pct + '%';
                }
            });
            xhr.addEventListener('load', () => {
                try {
                    resolve({ status: xhr.status, body: JSON.parse(xhr.responseText) });
                } catch {
                    resolve({ status: xhr.status, body: {} });
                }
            });
            xhr.addEventListener('error', () => reject(new Error('Network error')));
            xhr.addEventListener('abort', () => reject(new Error('Aborted')));
            xhr.open('POST', '/api/publish');
            xhr.setRequestHeader('X-Token', State.userToken);
            xhr.send(formData);
        });

        if (progBar) {
            progBar.fill.style.width = '100%';
            progBar.fill.style.background = 'var(--accent)';
            setTimeout(() => progBar.bar.remove(), 1000);
        }

        if (response.status === 200 || response.status === 201) {
            showToast('发布成功！', 'success');
            DOM.publishContent.value = '';
            clearDraft();
            clearImageSelection();
            State.pendingPublish = false;
            DOM.publishCard.classList.add('hidden');

            if (State.currentTab === 'all') {
                loadFeed(true);
            } else {
                switchTab('all');
            }
        } else if (response.status === 401 && response.body.code === 'NEED_AUTH') {
            showToast('管理权限失效，请重新进行验证', 'error');
            localStorage.removeItem('userToken');
            localStorage.removeItem('userPhone');
            State.userToken = null;
            State.userPhone = null;
            initUserBadge();
            openAuthModal('publish');
        } else {
            showToast(response.body.error || '发布失败', 'error');
        }
    } catch (err) {
        if (progBar) progBar.bar.remove();
        showToast('网络错误，发布失败，请稍后重试', 'error');
    } finally {
        DOM.btnPublish.disabled = false;
        DOM.btnPublish.textContent = '立即发布';
    }
};
